import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: React.ReactNode;
  isVisible: boolean;
}

export default function PageTransition({ children, isVisible }: PageTransitionProps) {
  const [shouldRender, setShouldRender] = useState(isVisible);
  const location = useLocation();
  const [transitionKey, setTransitionKey] = useState(location.pathname);

  useEffect(() => {
    if (isVisible) setShouldRender(true);
    setTransitionKey(location.pathname);
  }, [isVisible, location]);

  const handleAnimationEnd = () => {
    if (!isVisible) setShouldRender(false);
  };

  return shouldRender ? (
    <div
      key={transitionKey}
      className="page-transition"
      onAnimationEnd={handleAnimationEnd}
    >
      {children}
    </div>
  ) : null;
}